<template>
	<div id="CommonComment">
		<van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
			<van-list v-model="isLoading" :finished="isFinished" @load="onLoad">
				<div v-for="item in list" :key="item.id">
					<div class="item">
						<van-row type="flex">
							<img v-if="item.avatar == ''" src="../assets/skyworth.png" fit="cover" class="logo" />
							<van-image v-else :src="item.avatar" fit="cover" class="logo"></van-image>
							<div class="content-container">
								<div class="name">{{ item.real_name }}</div>
								<div class="content">{{ item.content }}</div>
								<div class="time">{{ item.time }}</div>
							</div>
						</van-row>
					</div>
					<van-divider />
				</div>
			</van-list>
		</van-pull-refresh>
		<div id="tool">
			<van-row>
				<van-col :span="inputing ? 20 : 16">
					<van-field
						class="fieldClass"
						v-model="text"
						placeholder="写下你的评论"
						maxlength="128"
						@blur="delayOnblur"
						@focus="inputing = true"
					/>
				</van-col>
				<van-col id="comment-icon" span="4" v-if="!inputing">
					<van-icon size="1.5625rem" name="comment-o" />
					{{ comment_count }}
				</van-col>
				<van-col id="like-icon" span="4" v-if="!inputing">
					<div>
						<van-icon v-if="di_likes" size="1.5625rem" name="like" @click="cancelLike" />
						<van-icon v-else size="1.5625rem" name="like-o" @click="submitLike" />
						{{ likes_count }}
					</div>
				</van-col>
				<van-col span="4" v-else>
					<van-button class="apply-btn" block size="large" type="info" @click="submitComment">发布</van-button>
				</van-col>
			</van-row>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
	props: ['type', 'comment_count', 'likes_count', 'di_likes', 'is_open'],
	data() {
		return {
			isLike: false,
			text: '',
			list: [],
			pageNo: 1,
			pageSize: 20,
			isRefresh: false,
			isLoading: false,
			isFinished: false,
			isliking: false, //点赞、取消赞 进行中
			user_id: null,
			inputing: false,
		}
	},
	computed: {
		isOpen() {
			return this.is_open
		},
		...mapGetters(['token', 'userId']),
	},
	methods: {
		submitLike() {
			if (this.isliking) return
			this.isliking = true
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/discusses/likes`,
				{
					type: this.type,
					topic_id: this.$route.query.id,
					user_id: this.user_id,
				},
				(res) => {
					this.$toast('点赞成功')
					this.di_likes = res.data.di_likes
					this.likes_count = res.data.likes_count
					this.isliking = false
				},
				() => {
					this.isliking = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},
		cancelLike() {
			if (this.isliking) return
			this.isliking = true
			this.vaxios.delete(
				`${this.vaxios.host}/api/v1/discusses/topic/` + this.$route.query.id + `/likes`,
				{
					type: this.type,
					topic_id: this.$route.query.id,
					user_id: this.user_id,
				},
				(res) => {
					this.$toast('取消点赞成功')
					this.isLike = true
					this.di_likes = res.data.di_likes
					this.likes_count = res.data.likes_count
					this.isliking = false
				},
				() => {
					this.isliking = false
				},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},

		submitComment() {
			if (!this.isOpen) {
				this.$toast('评论已关闭')
				return
			}
			if (this.text.trim() == '') {
				this.$toast('请输入评论内容')
				return
			}
			this.vaxios.post(
				`${this.vaxios.host}/api/v1/discusses/common`,
				{
					type: this.type,
					topic_id: this.$route.query.id,
					user_id: this.user_id,
					content: this.text,
				},
				() => {
					this.$toast('评论成功')
					this.text = ''
					this.onRefresh()
					this.$parent.getData()
				},
				() => {},
				{
					headers: {
						Authorization: 'Bearer ' + this.token,
						'Content-Type': 'application/json',
					},
				}
			)
		},
		onRefresh() {
			this.list = []
			this.pageNo = 1
			this.onLoad()
			this.isRefresh = false
		},
		onLoad() {
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/discusses/topic/${this.$route.query.id}/commons`,
				{
					pageNo: this.pageNo,
					pageSize: this.pageSize,
				},
				(res) => {
					let item
					let array = res.data.list
					for (let i = 0; i < array.length; i++) {
						let real_name = array[i].real_name
						if (!real_name || real_name == '') {
							real_name = array[i].user_id
						}
						let avatar = array[i].avatar
						if (!avatar || avatar == null) {
							avatar = ''
						}
						item = {
							id: array[i].id,
							name: array[i].user_id,
							content: array[i].content,
							time: moment(parseInt(array[i].update_time)).format('YYYY-MM-DD HH:mm:ss'),
							avatar: avatar,
							real_name: real_name,
						}
						this.list.push(item)
					}
					// 加载状态结束
					this.pageNo++
					this.isLoading = false

					// 数据全部加载完成
					if (this.list.length >= res.data.total) {
						this.isFinished = true
					}
				},
				function(err) {
					console.log(err)
				}
			)
		},
		delayOnblur() {
			let tiimer = setTimeout(() => {
				this.inputing = false
				clearTimeout(tiimer)
			}, 100)
		},
	},
}
</script>

<style>
#CommonComment {
	margin-left: 1rem;
	width: 90%;
}

.item {
	width: 100%;
}

.logo {
	width: 1.5rem;
	height: 1.5rem;
}

.name {
	color: #272727;
	font-size: 0.9375rem;
	margin-left: 20px;
}

.content {
	min-height: 3.125rem;
	margin-top: 0.34375rem;
	color: #272727;
	font-size: 1rem;
	font-weight: 500;
	margin-left: 20px;
}

.time {
	margin-top: 0.34375rem;
	color: #8d8d8d;
	font-size: 0.75rem;
	margin-left: 20px;
}

#tool {
	width: 100%;
	height: 50px;
	background-color: #ffffff;
	position: fixed;
	bottom: 0px;
	border-top: 0.9px solid rgba(0, 0, 0, 0.08627450980392157);
	margin-left: -1rem;
}

.van-divider {
	padding: 0 1rem;
	margin: 0;
}

.fieldClass {
	margin-left: 8px;
}

#like-icon,
#comment-icon {
	text-align: center;
	font-size: 0.6875rem;
	margin-top: 0.875rem;
}

.van-list__finished-text {
	background-color: #f5f5f5;
	margin-bottom: 3.28125rem;
}

.van-list .van-divider {
	margin-top: 0.96875rem;
	margin-bottom: 0.875rem;
	padding: 0;
}
</style>
